<template>
  <div>
    <v-row
      v-if="
        (loadingIpFirewallAddressList || loadingMainIpRoutes || loadingGroupIpRoutes) &&
          !ipFirewallAddressList &&
          !mainIpRoutes &&
          !groupIpRoutes
      "
      align="center"
      justify="center"
      no-gutters
      class="my-6"
    >
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-row>
    <template v-else-if="ipFirewallAddressList && mainIpRoutes && groupIpRoutes">
      <v-card-text class="d-flex justify-end">
        <v-btn color="primary" depressed :disabled="loadingGroupIpRoutes" @click="newGroupDialogShow = true">
          <v-icon left>mdi-plus</v-icon>
          Add group
        </v-btn>
      </v-card-text>
      <v-simple-table>
        <thead>
          <tr>
            <th class="text-left">Group</th>
            <th v-for="(mainIpRoute, distance) in mainIpRoutes" :key="mainIpRoute['.id']" class="text-left">
              Priority {{ distance + 1 }}
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td :colspan="mainIpRoutes.length + 2" style="height: 0; border: none" class="pa-0">
              <v-progress-linear
                v-if="loadingGroupIpRoutes"
                color="primary"
                height="6"
                indeterminate
              ></v-progress-linear>
            </td>
          </tr>
          <tr v-for="ipFirewallAddress in ipFirewallAddressList" :key="ipFirewallAddress['.id']">
            <td class="text-no-wrap">
              <div class="d-flex align-center">
                <v-tooltip v-if="!groupHasInternet(mainIpRoutes, ipFirewallAddress)" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-icon color="error" class="mr-2">mdi-alert-circle-outline</v-icon>
                    </span>
                  </template>
                  <span>This group has no connection to the internet. Please check the interfaces.</span>
                </v-tooltip>
                <div>
                  <div>{{ ipFirewallAddress.list }}</div>
                  <div class="caption grey--text text--darken-1">{{ ipFirewallAddress.address }}</div>
                </div>
              </div>
            </td>
            <td v-for="(mainIpRoute, distance) in mainIpRoutes" :key="mainIpRoute['.id']" class="text-no-wrap">
              <v-select
                :disabled="loadingGroupIpRoutes"
                class="my-3"
                :items="[...[{ comment: '', 'immediate-gw': '', gateway: null, interface: '' }], ...mainIpRoutes]"
                item-value="gateway"
                item-text="interface"
                hide-details
                dense
                outlined
                :value="
                  findGroupIpRouteByFirewallAddressAndDistance(ipFirewallAddress, distance + 1)
                    ? findGroupIpRouteByFirewallAddressAndDistance(ipFirewallAddress, distance + 1).gateway
                    : null
                "
                @change="
                  updateRouterosGroupIpRoute(
                    ipFirewallAddress,
                    distance + 1,
                    $event,
                    findGroupIpRouteByFirewallAddressAndDistance(ipFirewallAddress, distance + 1)
                  )
                "
              >
                <template v-slot:item="{ item }">
                  {{
                    item['interface']
                      ? item['interface']
                      : item['immediate-gw']
                      ? item['immediate-gw'].split('%')[1]
                      : item.comment
                  }}
                </template>
                <template v-slot:selection="{ item }">
                  <v-icon
                    v-if="interfaceConnectionColor(ipFirewallAddress, distance)"
                    size="18"
                    left
                    :color="interfaceConnectionColor(ipFirewallAddress, distance)"
                    >mdi-circle</v-icon
                  >
                  {{
                    item['interface']
                      ? item['interface']
                      : item['immediate-gw']
                      ? item['immediate-gw'].split('%')[1]
                      : item.comment
                  }}
                </template>
              </v-select>
            </td>
            <td class="text-no-wrap">
              <v-btn :disabled="loadingGroupIpRoutes" icon @click="deleteGroup(ipFirewallAddress['.id'])">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <div class="pb-12 pa-4">
        <v-row justify="center">
          <v-col cols="auto">
            <div class="legend-color green"></div>
            <div class="legend-label">
              <v-icon size="18" color="green" class="pr-1">
                mdi-circle
              </v-icon>
              Internet connection
            </div>
          </v-col>
          <v-col cols="auto">
            <div class="legend-color red"></div>
            <div class="legend-label">
              <v-icon size="18" color="red" class="pr-1">
                mdi-circle
              </v-icon>
              No internet connection
            </div>
          </v-col>
        </v-row>
      </div>
      <MikrotikGroupDialog
        v-if="!loadingGroupIpRoutes"
        v-model="newGroupDialogShow"
        :site-vpn="siteVpn"
        @created="getAll"
      />
    </template>
  </div>
</template>
<script>
import fetch from '@/utils/fetch'
import MikrotikGroupDialog from '@/components/Vpn/MikrotikGroupDialog.vue'

export default {
  name: 'SiteVpnMikrotikGroups',
  components: { MikrotikGroupDialog },
  props: {
    siteVpn: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loadingIpFirewallAddressList: false,
      ipFirewallAddressList: null,
      newGroupDialogShow: false,
      mainIpRoutes: null,
      loadingMainIpRoutes: false,
      groupIpRoutes: null,
      loadingGroupIpRoutes: false,
      loadingEthernetInterfaces: false,
      ethernetInterfaces: [],
      updateInterfaceDisabledLoading: false,
      loadingInternetState: false,
      isLoading: false,
      internetState: []
    }
  },
  computed: {
    ethernetInterfacesItems() {
      if (!this.ethernetInterfaces || !this.internetState) {
        return
      }
      this.ethernetInterfaces.forEach(item1 => {
        const matchingItem = this.internetState.find(item2 => item2['.id'] === item1['.id'])
        if (matchingItem) {
          item1.state = matchingItem.state
        }
      })
      return this.ethernetInterfaces
    },
    totalInterfacesConnection() {
      return this.ethernetInterfacesItems.filter(item => item.disabled === 'false' && item.state === 'internet')
    }
  },

  mounted() {
    this.getAll()
    this.getRouterosEthernetInterfaces()
    this.getRouterosInternetState()
  },
  methods: {
    interfaceConnectionColor(ipFirewallAddress, distance) {
      const ipRoute = this.findGroupIpRouteByFirewallAddressAndDistance(ipFirewallAddress, distance + 1)

      if (!ipRoute) {
        return null
      }

      return this.checkInterfaceConnection(ipRoute) ? 'green' : 'red'
    },
    groupHasInternet(mainIpRoutes, ipFirewallAddress) {
      if (!mainIpRoutes) {
        return
      }
      let count = 0
      mainIpRoutes.forEach((mainIpRoute, distance) => {
        if (
          this.checkInterfaceConnection(
            this.findGroupIpRouteByFirewallAddressAndDistance(ipFirewallAddress, distance + 1)
          )
        ) {
          count++
        }
      })
      return count >= 1
    },
    checkInterfaceConnection(ipRouteName) {
      if (!ipRouteName) {
        return false
      }

      const interfaceName = ipRouteName.interface ? ipRouteName.interface : ipRouteName['immediate-gw'].split('%')[1]

      return this.totalInterfacesConnection.some(item => item.name === interfaceName)
    },
    resetAll() {
      this.ipFirewallAddressList = null
      this.mainIpRoutes = null
      this.groupIpRoutes = null
    },

    getAll() {
      this.getRouterosIpFirewallAddressList()
      this.getRouterosMainIpRoutes()
      this.getRouterosGroupIpRoutes()
    },

    getRouterosIpFirewallAddressList() {
      this.loadingIpFirewallAddressList = true
      fetch(this.siteVpn['@id'] + '/routeros/ip_firewall_address_list')
        .then(response => response.json())
        .then(data => {
          this.ipFirewallAddressList = data
        })
        .catch(e => {
          this.error = e
        })
        .finally(() => {
          this.loadingIpFirewallAddressList = false
        })
    },

    getRouterosMainIpRoutes() {
      this.loadingMainIpRoutes = true
      fetch(this.siteVpn['@id'] + '/routeros/main_ip_routes')
        .then(response => response.json())
        .then(data => {
          data.forEach(item => {
            delete item.disabled
          })

          this.mainIpRoutes = data
        })
        .catch(e => {
          this.error = e
        })
        .finally(() => {
          this.loadingMainIpRoutes = false
        })
    },

    getRouterosGroupIpRoutes() {
      this.loadingGroupIpRoutes = true
      fetch(this.siteVpn['@id'] + '/routeros/group_ip_routes')
        .then(response => response.json())
        .then(data => {
          this.groupIpRoutes = data
        })
        .catch(e => {
          this.error = e
        })
        .finally(() => {
          this.loadingGroupIpRoutes = false
        })
    },

    findGroupIpRouteByFirewallAddressAndDistance(ipFirewallAddress, distance) {
      for (const item of Object.values(this.groupIpRoutes)) {
        if (item['routing-table'] === ipFirewallAddress.list && Number(item.distance) === distance) {
          return item
        }
      }

      return null
    },

    findGroupIpRouteByFirewallAddressDistanceAndGateway(ipFirewallAddress, distance, gateway) {
      for (const item of Object.values(this.groupIpRoutes)) {
        if (
          item['routing-table'] === ipFirewallAddress.list &&
          Number(item.distance) === distance &&
          item.gateway === gateway
        ) {
          return item
        }
      }

      return null
    },

    updateRouterosGroupIpRoute(ipFirewallAddress, distance, gateway, selectedIpRoute) {
      if (selectedIpRoute) {
        this.loadingGroupIpRoutes = true
        fetch(this.siteVpn['@id'] + '/routeros/ip_route/delete/' + selectedIpRoute['.id'], {
          method: 'DELETE'
        })
          .then(response => response.json())
          .then(() => {
            this.loadingGroupIpRoutes = false
            this.getAll()
          })
          .catch(e => {
            this.error = e
            this.resetAll()
            this.getAll()
          })
      }

      if (!gateway) {
        return
      }

      let ipRoute = null
      for (let x in this.mainIpRoutes) {
        ipRoute = this.findGroupIpRouteByFirewallAddressDistanceAndGateway(ipFirewallAddress, Number(x) + 1, gateway)
        if (ipRoute) {
          break
        }
      }

      if (ipRoute) {
        this.loadingGroupIpRoutes = true
        fetch(this.siteVpn['@id'] + '/routeros/ip_route/' + ipRoute['.id'], {
          method: 'PUT',
          body: JSON.stringify({
            'routing-table': ipFirewallAddress.list,
            gateway: gateway,
            distance: distance
          })
        })
          .then(response => response.json())
          .then(() => {
            this.loadingGroupIpRoutes = false
            this.getAll()
          })
          .catch(e => {
            this.resetAll()
            this.getAll()
            this.error = e
          })
      }

      if (!ipRoute) {
        this.loadingGroupIpRoutes = true
        fetch(this.siteVpn['@id'] + '/routeros/ip_route', {
          method: 'POST',
          body: JSON.stringify({
            'routing-table': ipFirewallAddress.list,
            distance: distance,
            gateway: gateway
          })
        })
          .then(response => response.json())
          .then(() => {
            this.loadingGroupIpRoutes = false
            this.getAll()
          })
          .catch(e => {
            this.error = e
            this.resetAll()
            this.getAll()
          })
      }
    },

    deleteGroup(ipFirewallAddressId) {
      this.loadingGroupIpRoutes = true
      fetch(this.siteVpn['@id'] + '/routeros/group/delete/' + ipFirewallAddressId, {
        method: 'DELETE'
      })
        .then(response => response.json())
        .then(() => {
          this.loadingGroupIpRoutes = false
          this.getAll()
        })
        .catch(e => {
          this.error = e
          this.resetAll()
          this.getAll()
        })
    },
    getRouterosInternetState() {
      this.loadingInternetState = true
      fetch(this.siteVpn['@id'] + '/routeros/internet_state')
        .then(response => response.json())
        .then(data => {
          this.internetState = data
        })
        .catch(e => {
          this.error = e
        })
        .finally(() => {
          this.loadingInternetState = false
        })
    },
    getRouterosEthernetInterfaces() {
      this.loadingEthernetInterfaces = true
      fetch(this.siteVpn['@id'] + '/routeros/ethernet_interfaces')
        .then(response => response.json())
        .then(data => {
          this.ethernetInterfaces = data
        })
        .catch(e => {
          this.error = e
        })
        .finally(() => {
          this.loadingEthernetInterfaces = false
        })
    }
  }
}
</script>
